<template>
  <the-business :data="business" />
</template>

<script>
import TheBusiness from '@/components/TheBusiness'

export default {
  components: { TheBusiness },
  async asyncData({ app, $winstonLog }) {
    try {
      const business = await app.$axios.get('/wbhome/business')
      return { business: (business.data && business.data.data) || [] }
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
      return { business: [] }
    }
  },
}
</script>
